import { render, staticRenderFns } from "./CampaignNews.vue?vue&type=template&id=5a29ac50"
import script from "./CampaignNews.vue?vue&type=script&lang=js"
export * from "./CampaignNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports